import {cardTitle, tooltip} from "assets/jss/material-dashboard-pro-react.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import customInfoLabels from "assets/jss/material-dashboard-pro-react/customInfoLabels.jsx";

const formacoesStyle = {
  ...customCheckboxRadioSwitch,
  ...customInfoLabels,
  tooltip,
  cardTitle,
};

export default formacoesStyle;
